<template>
  <button :class="`btn-back-to-top ${showBtn ? '' : 'none'}`" @click="backToTop">
    <Icon name="arrow_up"/>
    <span>{{ $t(isMobile) }}</span>
  </button>
</template>

<script>
export default {
  components: {
    Icon: () => import('./Icon.vue'),
  },
  props: {
    idElement: { type: String, default: 'content' },
    toTopID: { type: String, default: 'content' },
    isShowBtn: { type: Boolean, default: false },
    isNotAction: { type: Boolean, default: false },
  },
  data () {
    return {
      showBtn: this.isShowBtn,
    }
  },
  watch: {
    isShowBtn (value) {
      this.showBtn = value
    },
  },
  computed: {
    isMobile () {
      return this.$store.state.windowWidth < 768 ? 'top' : 'back_to_top'
    },
  },
  async mounted () {
    await this.$nextTick()
    document.getElementById(this.idElement).addEventListener('scroll', this.checkTop)
  },
  methods: {
    checkTop () {
      this.showBtn = document.getElementById(this.idElement).scrollTop - 100 > 0
    },
    backToTop () {
      if (!this.isNotAction) {
        const searchPageElement = document.getElementById(this.toTopID)
        searchPageElement.classList.add('scroll-animation')
        searchPageElement.scrollIntoView({ behavior: 'smooth' })
        setTimeout(() => {
          searchPageElement.classList.remove('scroll-animation')
        }, 500)
      }
    }
  }
}
</script>

<style lang="scss">
button.btn-back-to-top {
  border-radius: $border-radius-md;
  background-color: $color-cool-grey-500;
  color: $color-white;
  font-size: $text-sm;
  box-shadow: $shadow-md;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  float: right;
  padding: $space-2xs $space-sm;
  margin-top: $space-2xl;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0px;
  z-index: 999;
  margin-right: $space-sm;
  animation: scale-display .3s;
  -webkit-animation: scale-display .3s;

  &.none {
    animation: scale-none-display .3s forwards;
    -webkit-animation: scale-none-display .3s forwards;
    // display: none;
    // animation-direction: reverse;
  }
}

@keyframes scale-display {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@keyframes scale-none-display {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 0;
    display: none;
  }
}
</style>